import { c as _c } from "react/compiler-runtime";
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import useSession from '@/hooks/use-session';
type InviteOrgMemberProps = {
  detail: AuditEventDetail;
  hasPrincipalActor: boolean;
};
const InviteOrgMember = t0 => {
  const $ = _c(19);
  const {
    detail,
    hasPrincipalActor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.invite"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  const {
    data: t2
  } = useSession();
  const {
    org
  } = t2;
  if (detail.kind !== "invite_org_member") {
    return null;
  }
  const {
    firstName,
    lastName
  } = detail.data;
  let t3;
  if ($[1] !== hasPrincipalActor || $[2] !== t) {
    t3 = hasPrincipalActor ? t(_temp) : capitalize(t(_temp2));
    $[1] = hasPrincipalActor;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="text-body-2 text-tertiary">{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = firstName && lastName ? `${firstName} ${lastName}` : "a member";
  let t6;
  if ($[6] !== t5) {
    t6 = <span className="text-label-2">{t5}</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t) {
    t7 = t(_temp3);
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <span className="text-body-2 text-tertiary">{t7}</span>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = org?.name;
  let t10;
  if ($[12] !== t9) {
    t10 = <span className="text-label-2">{t9}</span>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t4 || $[16] !== t6 || $[17] !== t8) {
    t11 = <>{t4}{t6}{t8}{t10}</>;
    $[14] = t10;
    $[15] = t4;
    $[16] = t6;
    $[17] = t8;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};
export default InviteOrgMember;
function _temp($) {
  return $.invited;
}
function _temp2($_0) {
  return $_0.invited;
}
function _temp3($_1) {
  return $_1.toJoin;
}